import React, { useEffect, useRef } from "react";

function RadioButtonGroup({
  data,
  uniqueName,
  checked,
  setChecked,
  grid = "4",
  noIcon,
  setSelectedItem,
}) {
  const ref = useRef(null);

  return (
    <fragment
      className={
        !grid
          ? `grid grid-cols-4 gap-4 w-full radioGroup`
          : `grid grid-cols-${grid} gap-4 w-full radioGroup`
      }
    >
      {data?.map((item, index) => {
        return (
          <label
            htmlFor={`radio${uniqueName + index}`}
            key={index}
            className={`${
              item?.disabled
                ? "opacity-50 cursor-not-allowed"
                : "cursor-pointer"
            } select-none border-2 border-border-darkNew flex-1 p-3 rounded-xl flex flex-row gap-3 items-center font-N_Roman text-sm  ${
              item?.value === checked && "border-primary bg-primary-foreground"
            }`}
          >
            <input
              type="radio"
              id={`radio${uniqueName + index}`}
              name={`radio${uniqueName}`}
              value={item.value}
              className={`appearance-none border border-border-darkNew w-4 h-4 rounded-full aspect-square
    checked:bg-[var(--primary)] checked:border-[var(--primary)]
    disabled:opacity-50 disabled:cursor-not-allowed
    ${noIcon && "hidden"} text-base`}
              checked={checked === item.value}
              disabled={item?.disabled}
              onChange={(e) => {
                if (!item?.disabled) {
                  setChecked(e.target.value);
                  setSelectedItem && setSelectedItem(item?.challenge);
                }
              }}
            />

            {item.label}
          </label>
        );
      })}
    </fragment>
  );
}

export default RadioButtonGroup;
